import { __decorate, __metadata } from 'tslib';
import { Component, NgModule } from '@angular/core';
import { ModalController, NavController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let uiCModalBankLiquidatorComponent = class uiCModalBankLiquidatorComponent {
    constructor(modalController, navCtrl) {
        this.modalController = modalController;
        this.navCtrl = navCtrl;
    }
    ngOnInit() {
    }
    dismiss() {
        this.modalController.dismiss({
            dismissed: true,
        });
    }
};
uiCModalBankLiquidatorComponent = __decorate([
    Component({
        selector: 'ui-c-modal-bank-liquidator',
        template: "<div\n  class=\"ui-c-modal-limit-rate-inner ui-c-modal-liquidator-bank mt-3\">\n  <ion-row>\n    <ion-row>\n      <ion-col size=\"12\" class=\"text-center\">\n        <h2 class=\"header-title font-size-18 font-weight-bold\">\n          <!-- Informa\u00E7\u00F5es importantes! -->\n          {{ 'BANK_LIQUIDATOR.TITLE' | wlpTranslate }}\n        </h2>\n        <p class=\"lead-text\">\n          {{ 'BANK_LIQUIDATOR.TEXT_1' | wlpTranslate }}          \n        </p>\n        <!-- <h2 class=\"header-title font-size-18\">{{ 'LIMITS_RATE.HEADER.TWO' | wlpTranslate }}</h2> -->\n      </ion-col>\n    </ion-row>\n  \n    <ion-row class=\"content-values\">\n      <ion-col>\n        <ion-row class=\"w-100\">\n          <div class=\"services\">\n            <h4>\n              {{ 'BANK_LIQUIDATOR.TITLE_LI' | wlpTranslate }}\n            </h4>\n  \n            <li>{{ 'BANK_LIQUIDATOR.TEXT_LI_1' | wlpTranslate }} </li>\n            <li>{{ 'BANK_LIQUIDATOR.TEXT_LI_2' | wlpTranslate }}</li>\n            <li>{{ 'BANK_LIQUIDATOR.TEXT_LI_3' | wlpTranslate }}</li>\n            <small>{{ 'BANK_LIQUIDATOR.TEXT_LI_SMALL' | wlpTranslate }}</small>\n          </div>\n        </ion-row>\n      </ion-col>\n    </ion-row>\n  \n    <ion-col size=\"12\" class=\"limit-text-two text-center\">\n      <p>\n\n        {{ 'BANK_LIQUIDATOR.TEXT_P_1' | wlpTranslate }}\n      </p>\n      <p>\n        {{ 'BANK_LIQUIDATOR.TEXT_P_2' | wlpTranslate }}\n      </p>\n\n      <p>\n        {{ 'BANK_LIQUIDATOR.TEXT_P_URBANO' | wlpTranslate }}\n      </p>\n    </ion-col>\n\n    <ion-col size=\"12\" class=\"text-center\">\n      <ion-button class=\"ion-button\" (click)=\"dismiss()\">\n        <ion-icon name=\"thumbs-up\" class=\"mr-2\"></ion-icon>\n        <ion-label class=\"mt-1\">{{ 'LIMITS_RATE.BUTTON' | wlpTranslate }}</ion-label>\n      </ion-button>\n    </ion-col>\n  </ion-row>\n</div>"
    }),
    __metadata("design:paramtypes", [ModalController,
        NavController])
], uiCModalBankLiquidatorComponent);

let uiCModalBankLiquidatorModule = class uiCModalBankLiquidatorModule {
};
uiCModalBankLiquidatorModule = __decorate([
    NgModule({
        declarations: [uiCModalBankLiquidatorComponent],
        imports: [IonicModule, CommonModule, UiBsTranslateModule],
        exports: [uiCModalBankLiquidatorComponent],
    })
], uiCModalBankLiquidatorModule);

export { uiCModalBankLiquidatorComponent, uiCModalBankLiquidatorModule };
//# sourceMappingURL=wlp-ui-c-modal-bank-liquidator.js.map
